export interface OrderItem {
  productId: string;
  nameEn: string;
  nameAr: string;
  imageUrl: string;
  price: number;
  quantity: number;
  selectedVariants: Record<string, string>;
}

export interface Order {
  id: string;
  orderNumber: string;
  date: string;
  status: "processing" | "shipped" | "delivered" | "cancelled";
  items: OrderItem[];
  subtotal: number;
  shipping: number;
  tax: number;
  total: number;
  shippingAddress: {
    fullName: string;
    street: string;
    city: string;
    state: string;
    zip: string;
    country: string;
    phone: string;
  };
  paymentMethod: {
    type: string;
    last4: string;
  };
  trackingNumber: string | null;
  estimatedDelivery: string | null;
}

export const mockOrders: Order[] = [
  {
    id: "ord-001",
    orderNumber: "GS-2026-10042",
    date: "2026-06-20",
    status: "delivered",
    items: [
      {
        productId: "prod-1",
        nameEn: "Wireless Noise-Canceling Headphones",
        nameAr: "سماعات لاسلكية عازلة للضوضاء",
        imageUrl: "https://readdy.ai/api/search-image?query=Premium%20wireless%20over-ear%20headphones%20in%20matte%20black%20on%20clean%20warm%20cream%20background%2C%20minimalist%20product%20photography%20with%20soft%20diffused%20studio%20lighting%2C%20front%20view&width=200&height=200&seq=ord-item-hp&orientation=squarish",
        price: 129.99,
        quantity: 1,
        selectedVariants: { Color: "Matte Black" },
      },
      {
        productId: "prod-8",
        nameEn: "Organic Cotton Tote Bag",
        nameAr: "حقيبة قطن عضوي",
        imageUrl: "https://readdy.ai/api/search-image?query=Stylish%20organic%20cotton%20canvas%20tote%20bag%20in%20natural%20beige%20on%20clean%20warm%20cream%20background%2C%20minimalist%20product%20photography%20front%20view%20with%20soft%20lighting&width=200&height=200&seq=ord-item-tote&orientation=squarish",
        price: 24.99,
        quantity: 2,
        selectedVariants: { Color: "Natural" },
      },
    ],
    subtotal: 179.97,
    shipping: 0,
    tax: 14.40,
    total: 194.37,
    shippingAddress: {
      fullName: "Customer User",
      street: "45 Nile Corniche, Apt 12B",
      city: "Cairo",
      state: "Cairo Governorate",
      zip: "11511",
      country: "Egypt",
      phone: "+20 101 234 5678",
    },
    paymentMethod: {
      type: "Visa",
      last4: "4242",
    },
    trackingNumber: "DHL-8291-4736-01",
    estimatedDelivery: "2026-06-22",
  },
  {
    id: "ord-002",
    orderNumber: "GS-2026-10089",
    date: "2026-06-21",
    status: "shipped",
    items: [
      {
        productId: "prod-4",
        nameEn: "Vitamin C Brightening Serum",
        nameAr: "سيروم فيتامين سي للتفتيح",
        imageUrl: "https://readdy.ai/api/search-image?query=Premium%20vitamin%20C%20serum%20in%20amber%20glass%20bottle%20with%20dropper%20on%20clean%20warm%20cream%20background%2C%20luxury%20skincare%20product%20photography%20front%20view&width=200&height=200&seq=ord-item-serum&orientation=squarish",
        price: 34.99,
        quantity: 1,
        selectedVariants: { Size: "50ml" },
      },
      {
        productId: "prod-12",
        nameEn: "Natural Lip Balm Set",
        nameAr: "مجموعة مرطب شفاه طبيعي",
        imageUrl: "https://readdy.ai/api/search-image?query=Set%20of%20natural%20lip%20balms%20in%20small%20tins%20arranged%20neatly%20on%20clean%20warm%20cream%20background%2C%20minimalist%20product%20photography%20with%20soft%20lighting&width=200&height=200&seq=ord-item-lip&orientation=squarish",
        price: 16.99,
        quantity: 1,
        selectedVariants: {},
      },
    ],
    subtotal: 51.98,
    shipping: 0,
    tax: 4.16,
    total: 56.14,
    shippingAddress: {
      fullName: "Customer User",
      street: "45 Nile Corniche, Apt 12B",
      city: "Cairo",
      state: "Cairo Governorate",
      zip: "11511",
      country: "Egypt",
      phone: "+20 101 234 5678",
    },
    paymentMethod: {
      type: "Mastercard",
      last4: "8888",
    },
    trackingNumber: "ARAMEX-5512-9901-03",
    estimatedDelivery: "2026-06-25",
  },
  {
    id: "ord-003",
    orderNumber: "GS-2026-10115",
    date: "2026-06-22",
    status: "processing",
    items: [
      {
        productId: "prod-15",
        nameEn: "Bamboo Cutting Board Set",
        nameAr: "مجموعة ألواح تقطيع من الخيزران",
        imageUrl: "https://readdy.ai/api/search-image?query=Set%20of%20three%20bamboo%20cutting%20boards%20in%20different%20sizes%20stacked%20on%20clean%20warm%20cream%20background%2C%20minimalist%20kitchen%20product%20photography&width=200&height=200&seq=ord-item-board&orientation=squarish",
        price: 34.99,
        quantity: 1,
        selectedVariants: {},
      },
      {
        productId: "prod-6",
        nameEn: "Japanese Chef Knife Set",
        nameAr: "مجموعة سكاكين طاهٍ يابانية",
        imageUrl: "https://readdy.ai/api/search-image?query=Premium%20Japanese%20chef%20knife%20set%20on%20wooden%20magnetic%20block%20on%20clean%20warm%20cream%20background%2C%20professional%20product%20photography%20front%20view&width=200&height=200&seq=ord-item-knife&orientation=squarish",
        price: 149.99,
        quantity: 1,
        selectedVariants: {},
      },
    ],
    subtotal: 184.98,
    shipping: 0,
    tax: 14.80,
    total: 199.78,
    shippingAddress: {
      fullName: "Customer User",
      street: "45 Nile Corniche, Apt 12B",
      city: "Cairo",
      state: "Cairo Governorate",
      zip: "11511",
      country: "Egypt",
      phone: "+20 101 234 5678",
    },
    paymentMethod: {
      type: "Visa",
      last4: "4242",
    },
    trackingNumber: null,
    estimatedDelivery: "2026-06-28",
  },
  {
    id: "ord-004",
    orderNumber: "GS-2026-09783",
    date: "2026-06-10",
    status: "delivered",
    items: [
      {
        productId: "prod-5",
        nameEn: "Insulated Stainless Steel Bottle",
        nameAr: "زجاجة ستانلس ستيل معزولة",
        imageUrl: "https://readdy.ai/api/search-image?query=Sleek%20stainless%20steel%20insulated%20water%20bottle%20in%20matte%20black%20finish%20on%20clean%20warm%20cream%20background%2C%20minimalist%20product%20photography%20front%20view&width=200&height=200&seq=ord-item-bottle&orientation=squarish",
        price: 28.99,
        quantity: 2,
        selectedVariants: { Color: "Matte Black", Size: "750ml" },
      },
    ],
    subtotal: 57.98,
    shipping: 5.99,
    tax: 5.12,
    total: 69.09,
    shippingAddress: {
      fullName: "Customer User",
      street: "45 Nile Corniche, Apt 12B",
      city: "Cairo",
      state: "Cairo Governorate",
      zip: "11511",
      country: "Egypt",
      phone: "+20 101 234 5678",
    },
    paymentMethod: {
      type: "Visa",
      last4: "4242",
    },
    trackingNumber: "DHL-7290-3381-00",
    estimatedDelivery: "2026-06-13",
  },
  {
    id: "ord-005",
    orderNumber: "GS-2026-09541",
    date: "2026-06-01",
    status: "cancelled",
    items: [
      {
        productId: "prod-9",
        nameEn: "Smart Fitness Watch",
        nameAr: "ساعة لياقة ذكية",
        imageUrl: "https://readdy.ai/api/search-image?query=Modern%20smart%20fitness%20watch%20with%20sleek%20design%20on%20clean%20warm%20cream%20background%2C%20minimalist%20product%20photography%20front%20view%20with%20soft%20lighting&width=200&height=200&seq=ord-item-watch&orientation=squarish",
        price: 199.99,
        quantity: 1,
        selectedVariants: { Size: "44mm", Color: "Midnight Black" },
      },
    ],
    subtotal: 199.99,
    shipping: 0,
    tax: 16.00,
    total: 215.99,
    shippingAddress: {
      fullName: "Customer User",
      street: "45 Nile Corniche, Apt 12B",
      city: "Cairo",
      state: "Cairo Governorate",
      zip: "11511",
      country: "Egypt",
      phone: "+20 101 234 5678",
    },
    paymentMethod: {
      type: "Mastercard",
      last4: "8888",
    },
    trackingNumber: null,
    estimatedDelivery: null,
  },
];

export const statusLabelsEn: Record<Order["status"], string> = {
  processing: "Processing",
  shipped: "Shipped",
  delivered: "Delivered",
  cancelled: "Cancelled",
};

export const statusLabelsAr: Record<Order["status"], string> = {
  processing: "قيد المعالجة",
  shipped: "تم الشحن",
  delivered: "تم التوصيل",
  cancelled: "ملغي",
};